(function($) {
  var selector = ".custom-lazyload-block";

  var $slides = $(selector);

  var currentSlide = 0;
  var isAnimating = false;

  var stopAnimation = function() {
	  
	
    setTimeout(function() {
      isAnimating = false;
    }, 100);
  };

  var bottomIsReached = function($elem) {
    var rect = $elem[0].getBoundingClientRect();
    return rect.bottom <= $(window).height();
  };

  var topIsReached = function($elem) {
    var rect = $elem[0].getBoundingClientRect();
    return rect.top >= 0;
  };

  document.addEventListener(
    "wheel",
    function(event) {
   var $currentSlide = $($slides[currentSlide]);

      if (isAnimating) {
        event.preventDefault();
        return;
      }

      var direction = -event.deltaY;

      if (direction < 0) {
        // next
        if (currentSlide + 1 >= $slides.length) return;
        if (!bottomIsReached($currentSlide)) return;
        event.preventDefault();
        currentSlide++;
        var $slide = $($slides[currentSlide]);
        var offsetTop = $slide.offset().top;
        isAnimating = true;
        $("html, body").animate(
          {
            scrollTop: offsetTop-100
          },
          1000,
          stopAnimation
        );
      } else {
        // back
        if (currentSlide - 1 < 0) return;
        if (!topIsReached($currentSlide)) return;
        event.preventDefault();
        currentSlide--;
        var $slide = $($slides[currentSlide]);
        var offsetTop = $slide.offset().top;
        isAnimating = true;
        $("html, body").animate(
          {
            scrollTop: offsetTop-100
          },
          1000,
          stopAnimation
        );
      }
    },
    { passive: false }
  );
 
  ////// for mobile device
 var ts;
$(document).bind('touchstart', function (e){
   ts = e.originalEvent.touches[0].clientY;
});
$(document).bind('touchend', function (event){
   var te = event.originalEvent.changedTouches[0].clientY;
  
 var $currentSlide = $($slides[currentSlide]);
   if (isAnimating) {
        event.preventDefault();
        return;
      }
      if (isAnimating) {
        event.preventDefault();
        return;
      }
		
      if (ts > te+5) {
        if (currentSlide + 1 >= $slides.length) return;
        if (!bottomIsReached($currentSlide)) return;
        event.preventDefault();
        currentSlide++;
         var $slide = $($slides[currentSlide]);
        var offsetTop = $slide.offset().top;
        isAnimating = true;
        $("html, body").animate(
          {
            scrollTop: offsetTop-80
          },
          1000,
          stopAnimation
        );
        
        
      } else {
        // back
        if (currentSlide - 1 < 0) return;
        if (!topIsReached($currentSlide)) return;
        event.preventDefault();
        currentSlide--;
        var $slide = $($slides[currentSlide]);
        var offsetTop = $slide.offset().top;
        isAnimating = true;
        $("html, body").animate(
          {
            scrollTop: offsetTop-80
          },
          1000,
          stopAnimation
        );
       
      }
    }
  );
  
  
  
  
  
  
  

  
  
 ////////////////////////////////// 

})(jQuery);


$(document).on('touchmove', function() { //touchmove works for iOS, I don't know if Android supports it
  //$(document).trigger('wheel');
  
});
